import styled from '@emotion/styled'
import { withClass } from 'common/emotion'

import { metrics, colors } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { breakWords } from 'component-library/__styling/style-mixins'
import { Theme } from 'component-library/__styling/themes'

import { themedValue } from 'component-library/__styling/themed-value'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { SectionHeader } from 'component-library/section-header/SectionHeader/SectionHeader'
import { IconPremium } from 'component-library/icons/IconPremium/IconPremium'

export const styledListClassName = 'RelatedContent'
export const styledWrapperClassName = 'RelatedContentWrapper'

export interface StyledListProps {
    theme: Theme
}

export const StyledRelatedContentContainer = withClass(styledWrapperClassName)(
    styled('aside')(props => ({
        ...conditionalStyles(props.theme.kind === 'thewest', {
            padding: calcRem(props.theme.margins.md, 0, 0),
            borderTop: `1px solid ${colors.thewest.greyDolphin}`,
        }),
    }))
)

export const StyledRelatedContent = withClass(styledListClassName)(
    styled('ul')(
        {
            ...breakWords,
            listStyle: 'none',
            clear: 'both',
        },
        props => ({
            margin: themedValue(props.theme, {
                thewest: '0',
                perthnow: calcRem(0, 0, metrics.perthnow.textMargin, metrics.perthnow.margins.md),
                sevennews: `0 0 ${calcRem(metrics.sevennews.textMargin)} 0`,
                fallback: undefined,
            }),
            padding: themedValue(props.theme, {
                thewest: calcRem(0, props.theme.margins.md),
                fallback: calcRem(0, 16),
            }),
        })
    )
)

export interface StyledListItemProps {
    theme: Theme
}

export const StyledListItem = styled('li')(props => ({
    position: 'relative',

    '&::after': {
        content: `" "`,
        transform: `translate(-100%, -50%)`,
        left: '-7px',
        top: calcRem(12), // half the line-height of the text
        position: 'absolute',
        pointerEvents: 'none',
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4.5px 0 4.5px 7.8px',
        borderColor: `transparent transparent transparent ${colors.thewest.greyHippo}`,
    },

    margin: themedValue(props.theme, {
        thewest: calcRem(0, 0, props.theme.margins.sm, 0),
        perthnow: calcRem(0, 0, metrics.perthnow.margins.sm, 0),
        sevennews: calcRem(0, 0, metrics.sevennews.margins.sm, 0),
        fallback: undefined,
    }),
}))

export const StyledSectionHeader = styled(SectionHeader)(props => ({
    marginBottom: calcRem(props.theme.margins.md),
}))

export const StyledIconPremium = styled(IconPremium)({
    width: 17,
    height: 17,
    marginLeft: calcRem(1),
    verticalAlign: 'text-bottom',
})
